import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { IBanner } from "../../banners.types";
import { requestGetBanners } from "./getBanners.request";

const useBanners = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<IBanner>, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();
  const queryKey = ["banners", "admin", "all", requestParams];

  const { data, ...rest } = useQuery({
    queryKey,
    queryFn: async () => await requestGetBanners(requestParams),
    ...options
  });

  const setBanners = (newBanners: IBanner[]) => {
    queryClient.setQueriesData(queryKey, {
      data: newBanners,
      meta: data?.meta
    });
  };

  return { banners: data?.data ?? [], meta: data?.meta, setBanners, ...rest };
};

export default useBanners;
